import React from "react";

import styled from "styled-components";

import { ReactComponent as MoreIcon } from "assets/icons/moreIcon.svg";

type Props = {};

export function MoreDotsIcon(props: Props) {
  return <Icon {...props} />;
}

const Icon = styled(MoreIcon)`
  path {
    fill: ${({ theme }) => theme.palette.black};
  }
`;
